import React from "react"

const HamburgerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width="16"
      height="16"
    >
      <g fill="#fff">
        <path d="M14.8 3.6H1.2a1.2 1.2 0 010-2.4h13.6a1.2 1.2 0 010 2.4zM14.8 9.2H1.2a1.2 1.2 0 010-2.4h13.6a1.2 1.2 0 010 2.4zM14.8 14.8H1.2a1.2 1.2 0 010-2.4h13.6a1.2 1.2 0 010 2.4z" />
      </g>
    </svg>
  )
}

const ArrowDownIcon = ({ width = "8", height = "8", fill = "#126eb6" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 14"
      width={width}
      height={height}
    >
      <path
        fill={fill}
        d="M7 11.375a1.342 1.342 0 01-1.009-.455L.268 4.415a1.077 1.077 0 011.618-1.423L6.89 8.68a.146.146 0 00.22 0l5.004-5.69a1.077 1.077 0 111.618 1.424L8.01 10.918a1.348 1.348 0 01-1.01.457z"
      />
    </svg>
  )
}

const ArrowUpIcon = ({ width = "8", height = "8", fill = "#126eb6" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 14"
      width={width}
      height={height}
    >
      <path
        fill={fill}
        d="M12.293 10.6L7.177 5.487a.25.25 0 00-.354 0L1.707 10.6A1 1 0 11.293 9.189l5.646-5.646a1.5 1.5 0 012.122 0l5.646 5.646a1 1 0 11-1.414 1.411z"
      />
    </svg>
  )
}

const CartIcon = ({
  width = "16",
  height = "16",
  fill = "#fff",
  style = {},
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width={width}
      height={height}
      fill={fill}
      style={style}
    >
      <path d="M15.773 4.507a.667.667 0 0 0-.666-.84H3.7a.173.173 0 0 1-.167-.134l-.38-1.813A2.173 2.173 0 0 0 1.033 0a.833.833 0 0 0 0 1.667.5.5 0 0 1 .487.393l2.113 10.053A2.167 2.167 0 0 0 4.46 13.4a.173.173 0 0 1 .067.127.167.167 0 0 1-.06.133 1.333 1.333 0 1 0 2.2 1.007 1.333 1.333 0 0 0-.14-.594.153.153 0 0 1 0-.16.167.167 0 0 1 .14-.08h4a.167.167 0 0 1 .146.08.167.167 0 0 1 0 .16 1.273 1.273 0 0 0-.146.594 1.333 1.333 0 0 0 2.666 0 1.333 1.333 0 0 0-.146-.6.193.193 0 0 1 0-.16.167.167 0 0 1 .14-.074.833.833 0 1 0 0-1.666H5.753a.5.5 0 0 1-.486-.394l-.12-.573a.153.153 0 0 1 0-.14.167.167 0 0 1 .186-.06h7.147a2 2 0 0 0 1.927-1.473Z" />
    </svg>
  )
}

export { HamburgerIcon, ArrowDownIcon, ArrowUpIcon, CartIcon }
